"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldError = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const FieldDescription_1 = require("../FieldDescription/FieldDescription");
exports.StyledFieldError = (0, styled_components_1.default)(FieldDescription_1.FieldDescription) `
    display: flex;
    align-items: center;
    color: var(--ds-color-red-130);
    gap: 0.25rem;
    align-items: flex-start;

    /* This isn't pretty but since Form.Error is usually displayed below a form field, we set a default margin-top */
    margin-top: 0.25rem;

    svg {
        min-width: 24px;
        min-height: 24px;
    }
`;
//# sourceMappingURL=FieldError.styles.js.map